import { modalActions as modalActionsSlices } from '../slices/modals';

export default {
  ...modalActionsSlices,
};
